// SORRA interactions (null-guarded; safe on every template)
function jumpTo(slug){var t=document.getElementById('sec-'+slug);if(t)t.scrollIntoView({behavior:'smooth',block:'start'});}
document.querySelectorAll('.intent').forEach(function(b){b.addEventListener('click',function(){jumpTo(b.dataset.intent);});});
document.querySelectorAll('.intnav a').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();jumpTo(a.dataset.jump);});});
var cbtns=document.querySelectorAll('.cattoggle__btn');
cbtns.forEach(function(btn){btn.addEventListener('click',function(){var t=document.getElementById('view-'+btn.dataset.view);if(t)t.scrollIntoView({behavior:'smooth',block:'start'});});});
if('IntersectionObserver' in window){
  var catSpy=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var v=e.target.id.replace('view-','');cbtns.forEach(function(b){b.classList.toggle('active',b.dataset.view===v);});}});},{rootMargin:'-20% 0px -70% 0px',threshold:0});
  ['view-intentions','view-details','view-light'].forEach(function(id){var el=document.getElementById(id);if(el)catSpy.observe(el);});
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  var spy=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var slug=e.target.id.replace('sec-','');document.querySelectorAll('.intnav a').forEach(function(a){a.classList.toggle('active',a.dataset.jump===slug);});document.querySelectorAll('.intent').forEach(function(b){b.classList.toggle('active',b.dataset.intent===slug);});}});},{rootMargin:'-45% 0px -50% 0px',threshold:0});
  document.querySelectorAll('.chap').forEach(function(s){spy.observe(s);});
}
var nav=document.getElementById('nav');
if(nav){addEventListener('scroll',function(){nav.classList.toggle('solid',scrollY>window.innerHeight*0.7);},{passive:true});}
function toGuide(e){if(e)e.preventDefault();var g=document.getElementById('guide');if(g)g.scrollIntoView({behavior:'smooth'});}
var launcher=document.getElementById('launcher');if(launcher)launcher.addEventListener('click',toGuide);
var openGuide=document.getElementById('openGuide');if(openGuide)openGuide.addEventListener('click',toGuide);

// SORRA global premium header: predictive search + cart drawer on non-product templates.
(() => {
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  })[char]);

  const drawerElement = document.querySelector('[data-sorra-cart]');
  if (!window.SorraCart && drawerElement) {
    // Portals out of the sticky global header so fixed positioning is relative
    // to the viewport on mobile Safari and all other browsers.
    document.body.appendChild(drawerElement);
    window.SorraCart = (() => {
      let drawer = null, body = null, footer = null, subtotal = null, message = null;
      let lastFocus = null, closeTimer = null, currentRequest = 0;
      let activeCurrency = drawerElement.dataset.cartCurrency || window.Shopify?.currency?.active || 'USD';
      const routeRoot = drawerElement.dataset.cartRoot || window.Shopify?.routes?.root || '/';
      const formatMoney = (cents) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:activeCurrency }).format((Number(cents)||0)/100); }
        catch (_) { return `$${((Number(cents)||0)/100).toFixed(2)}`; }
      };
      const updateCounts = (count) => document.querySelectorAll('[data-sorra-cart-count]').forEach(el => { el.textContent = count; });
      const setMessage = (text = '') => { if (message) message.textContent = text; };
      const panel = () => drawer?.querySelector('.sorra-cart__panel');
      const reduceMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const finishClose = () => {
        if (!drawer || drawer.classList.contains('is-open')) return;
        drawer.hidden = true;
        drawer.setAttribute('aria-hidden','true');
      };
      const close = () => {
        if (!drawer || drawer.hidden) return;
        drawer.classList.remove('is-open');
        document.body.classList.remove('sorra-global-lock');
        window.clearTimeout(closeTimer);
        if (reduceMotion()) finishClose();
        else closeTimer = window.setTimeout(finishClose, 470);
        if (lastFocus instanceof HTMLElement && lastFocus.isConnected) lastFocus.focus({preventScroll:true});
      };
      const open = () => {
        if (!drawer) return;
        if (drawer.hidden) lastFocus = document.activeElement;
        window.clearTimeout(closeTimer);
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden','false');
        document.body.classList.add('sorra-global-lock');
        // Force the translated starting position before triggering animation.
        drawer.classList.remove('is-open');
        void drawer.offsetWidth;
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
          panel()?.focus({preventScroll:true});
        });
      };
      const itemMarkup = item => {
        const image = item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" loading="lazy">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="sorra-cart__variant">${esc(item.variant_title)}</div>` : '';
        return `<article class="sorra-cart__item" data-cart-key="${esc(item.key)}"><a class="sorra-cart__image" href="${esc(item.url)}">${image}</a><div><a class="sorra-cart__item-title" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}<div class="sorra-cart__qty"><button type="button" data-cart-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">&minus;</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button></div></div><div><div class="sorra-cart__price">${formatMoney(item.final_line_price)}</div><button class="sorra-cart__remove" type="button" data-cart-quantity="0">Remove</button></div></article>`;
      };
      const render = cart => {
        if (!body || !footer || !subtotal) return;
        activeCurrency = cart.currency || activeCurrency;
        updateCounts(cart.item_count || 0);
        if (!cart.item_count) {
          body.innerHTML = `<div class="sorra-cart__empty"><svg viewBox="0 0 64 64" aria-hidden="true"><path d="M20 23h24l-2 29H22l-2-29Zm6 0v-5a6 6 0 0 1 12 0v5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg><h3>Your bag is waiting.</h3><p>Choose the piece that feels most like where you are now.</p><button type="button" data-sorra-cart-close>Continue exploring</button></div>`;
          footer.hidden = true;
        } else {
          body.innerHTML = cart.items.map(itemMarkup).join('');
          subtotal.textContent = formatMoney(cart.total_price);
          footer.hidden = false;
        }
        body.querySelectorAll('[data-sorra-cart-close]').forEach(b => b.addEventListener('click',close));
        body.querySelectorAll('[data-cart-quantity]').forEach(b => b.addEventListener('click', async () => {
          const item = b.closest('[data-cart-key]');
          if (item) await change(item.dataset.cartKey,Number(b.dataset.cartQuantity));
        }));
      };
      const refresh = async (shouldOpen=false) => {
        const requestId = ++currentRequest;
        if (shouldOpen) {
          if (drawer?.hidden) setMessage('Loading your bag…');
          open();
        }
        try {
          const response = await fetch(`${routeRoot}cart.js`,{headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Unable to load your bag.');
          const cart = await response.json();
          if (requestId === currentRequest) { render(cart); setMessage(''); }
          return cart;
        } catch(error) {
          if (requestId === currentRequest) setMessage(error.message || 'Unable to load your bag.');
          return null;
        }
      };
      const change = async (key,quantity) => {
        setMessage('Updating…');
        try {
          const response=await fetch(`${routeRoot}cart/change.js`,{
            method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:key,quantity})
          });
          const cart=await response.json();
          if(!response.ok) throw new Error(cart.description||'Unable to update this piece.');
          currentRequest++;
          setMessage(''); render(cart);
        } catch(error) { setMessage(error.message||'Unable to update this piece.'); }
      };
      const mount = element => {
        if (!element || element.dataset.sorraCartMounted==='true') return;
        drawer=element; drawer.dataset.sorraCartMounted='true';
        drawer.setAttribute('aria-hidden','true');
        body=drawer.querySelector('[data-sorra-cart-body]');
        footer=drawer.querySelector('[data-sorra-cart-footer]');
        subtotal=drawer.querySelector('[data-sorra-cart-subtotal]');
        message=drawer.querySelector('[data-sorra-cart-message]');
        drawer.querySelectorAll('[data-sorra-cart-close]').forEach(b=>b.addEventListener('click',close));
        document.querySelectorAll('[data-sorra-cart-open]').forEach(b => {
          if(b.dataset.sorraCartBound==='true') return;
          b.dataset.sorraCartBound='true';
          b.addEventListener('click', () => { refresh(true); });
        });
        drawer.addEventListener('keydown', event => {
          if (event.key==='Escape') { event.preventDefault(); close(); return; }
          if (event.key!=='Tab') return;
          const focusables=[...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')]
            .filter(el=>el.getClientRects().length && !el.closest('[hidden]'));
          if (!focusables.length) return;
          const first=focusables[0], last=focusables[focusables.length-1];
          if(event.shiftKey && document.activeElement===first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement===last) { event.preventDefault(); first.focus(); }
        });
        refresh(false);
      };
      return {mount,open,close,refresh,change};
    })();
    window.SorraCart.mount(drawerElement);
    document.addEventListener('keydown', event => {
      if(event.key==='Escape' && !drawerElement.hidden) window.SorraCart.close();
    });
  }

  const search = document.querySelector('[data-sorra-global-search]');
  if (!search) return;
  const openButtons=document.querySelectorAll('[data-sorra-global-search-open]');
  const closeButtons=search.querySelectorAll('[data-sorra-global-search-close]');
  const input=search.querySelector('[data-sorra-global-search-input]');
  const results=search.querySelector('[data-sorra-global-search-results]');
  const form=search.querySelector('[data-sorra-global-search-form]');
  const suggestUrl=search.dataset.suggestUrl || `${window.Shopify?.routes?.root || '/'}search/suggest.json`;
  const searchUrl=search.dataset.searchUrl || `${window.Shopify?.routes?.root || '/'}search`;
  let timer=null, controller=null, lastFocus=null;
  const openSearch=()=>{ lastFocus=document.activeElement; search.hidden=false; document.body.classList.add('sorra-search-open'); requestAnimationFrame(()=>input?.focus()); };
  const closeSearch=()=>{ controller?.abort(); search.hidden=true; document.body.classList.remove('sorra-search-open'); if(lastFocus instanceof HTMLElement) lastFocus.focus(); };
  openButtons.forEach((b)=>b.addEventListener('click',openSearch)); closeButtons.forEach((b)=>b.addEventListener('click',closeSearch));
  const imageUrl=(image)=>!image?'':(typeof image==='string'?image:(image.url||image.src||''));
  const renderProducts=(products,query)=>{
    if(!results) return;
    if(!products.length){ results.innerHTML=`<p class="sorra-search-modal__status">No matching pieces found for “${esc(query)}”.</p><a class="sorra-live-search__all" href="${esc(searchUrl)}?type=product&q=${encodeURIComponent(query)}">View all search results</a>`; return; }
    const items=products.map((product)=>{ const image=imageUrl(product.image), type=product.type||product.vendor||'SORRA', price=product.price||''; return `<a class="sorra-live-search__item" href="${esc(product.url)}"><span class="sorra-live-search__image">${image?`<img src="${esc(image)}" alt="${esc(product.title)}" loading="lazy">`:''}</span><span class="sorra-live-search__meta"><span class="sorra-live-search__type">${esc(type)}</span><span class="sorra-live-search__title">${esc(product.title)}</span></span><span class="sorra-live-search__price">${esc(price)}</span></a>`; }).join('');
    results.innerHTML=`<p class="sorra-search-modal__status">Pieces matching “${esc(query)}”</p><div class="sorra-live-search__list">${items}</div><a class="sorra-live-search__all" href="${esc(searchUrl)}?type=product&q=${encodeURIComponent(query)}">View all results</a>`;
  };
  const fetchResults=async(query)=>{ controller?.abort(); controller=new AbortController(); results.innerHTML='<p class="sorra-search-modal__status">Searching…</p>'; try{ const url=new URL(suggestUrl,window.location.origin); url.searchParams.set('q',query); url.searchParams.set('resources[type]','product'); url.searchParams.set('resources[limit]','6'); url.searchParams.set('resources[options][unavailable_products]','last'); const response=await fetch(url.toString(),{headers:{Accept:'application/json'},signal:controller.signal}); if(!response.ok) throw new Error('Search is unavailable.'); const payload=await response.json(); renderProducts(payload?.resources?.results?.products||[],query); }catch(error){ if(error.name==='AbortError') return; results.innerHTML='<p class="sorra-search-modal__status">Live search is temporarily unavailable. Press Enter to search the store.</p>'; }};
  input?.addEventListener('input',()=>{ const query=input.value.trim(); window.clearTimeout(timer); if(query.length<2){ controller?.abort(); results.innerHTML='<p class="sorra-search-modal__status">Start typing to see matching pieces.</p>'; return; } timer=window.setTimeout(()=>fetchResults(query),220); });
  form?.addEventListener('submit',(event)=>{ if(!input?.value.trim()) event.preventDefault(); });
  document.addEventListener('keydown',(event)=>{ if(event.key==='Escape'&&!search.hidden) closeSearch(); });
})();

